var map = {
	"./banner-0.jpg": 4522,
	"./banner-1.jpg": 4782,
	"./banner-10.jpg": 6141,
	"./banner-11.jpg": 7288,
	"./banner-12.jpg": 3782,
	"./banner-13.jpg": 5895,
	"./banner-14.jpg": 1378,
	"./banner-15.jpg": 2037,
	"./banner-16.jpg": 9748,
	"./banner-17.jpg": 4079,
	"./banner-18.jpg": 3042,
	"./banner-19.jpg": 2122,
	"./banner-2.jpg": 7250,
	"./banner-3.jpg": 5914,
	"./banner-4.jpg": 2809,
	"./banner-5.jpg": 9296,
	"./banner-6.jpg": 8048,
	"./banner-7.jpg": 7893,
	"./banner-8.jpg": 1919,
	"./banner-9.jpg": 8114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7593;